var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-menuAccount" }, [
    _c("h2", { staticClass: "c-menuAccount_title" }, [
      _vm._v(_vm._s(_vm.username)),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "c-menuAccount_card" }, [
      _c(
        "nav",
        { staticClass: "m-menuList m-menuList--borderless" },
        _vm._l(_vm.userMenu.shared, function (item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "m-menuList_item",
              class: _vm.itemStyle(index, _vm.userMenu.shared),
              attrs: { target: _vm.itemTarget(item, _vm.userMenu.shared) },
            },
            [
              _c(_vm.getMenuItem(item.type), {
                tag: "component",
                attrs: {
                  data: item,
                  "display-selected": true,
                  "display-expanded": true,
                },
              }),
            ],
            1
          )
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _vm.company.isActive
      ? _c("h2", { staticClass: "c-menuAccount_title" }, [
          _vm._v("\n    " + _vm._s(_vm.company.name) + "\n  "),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.company.isActive
      ? _c("div", { staticClass: "c-menuAccount_card" }, [
          _c(
            "nav",
            { staticClass: "m-menuList m-menuList--borderless" },
            _vm._l(_vm.companyMenu.shared, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "m-menuList_item",
                  class: _vm.itemStyle(index, _vm.companyMenu.shared),
                  attrs: {
                    target: _vm.itemTarget(item, _vm.companyMenu.shared),
                  },
                },
                [
                  _c(_vm.getMenuItem(item.type), {
                    tag: "component",
                    attrs: {
                      data: item,
                      "display-selected": true,
                      "display-expanded": true,
                    },
                  }),
                ],
                1
              )
            }),
            0
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }